import React from 'react';
import { CopyableText } from 'src/shared/components';
import { CoordinatesName } from 'src/shared/enums';
import { CoordinateFormatType } from '../enums';
import type { CoordinateFormats } from '../types';

type PointCoordinatesDetailsProps = {
  format?: string;
  pointFeatureCoordinates: CoordinateFormats;
};

export const PointCoordinatesDetails: React.FC<
  PointCoordinatesDetailsProps
> = ({ format, pointFeatureCoordinates }) => {
  if (format === CoordinateFormatType.UTM) {
    const { zoneNumber, utmCoords, hemisphere } = pointFeatureCoordinates;

    return (
      <>
        <div>Zone - {`${zoneNumber}${hemisphere}`}</div>
        <CopyableText
          header={CoordinatesName.Northing}
          value={`${utmCoords.northing} N`}
          copyText={utmCoords.northing}
        />
        <CopyableText
          header={CoordinatesName.Easting}
          value={`${utmCoords.easting} E`}
          copyText={utmCoords.easting}
        />
      </>
    );
  }

  const { ddLatitude, ddLongitude, dmsLatitude, dmsLongitude } =
    pointFeatureCoordinates;
  const isDecimalDegrees = format === CoordinateFormatType.DecimalDegrees;

  return (
    <>
      <CopyableText
        header={CoordinatesName.Latitude}
        value={isDecimalDegrees ? `${ddLatitude} N` : dmsLatitude}
        copyText={isDecimalDegrees ? ddLatitude! : dmsLatitude!.slice(0, -1)}
      />
      <CopyableText
        header={CoordinatesName.Longitude}
        value={isDecimalDegrees ? `${ddLongitude} E` : dmsLongitude}
        copyText={isDecimalDegrees ? ddLongitude! : dmsLongitude!.slice(0, -1)}
      />
    </>
  );
};
